import { render } from "./Backorder.vue?vue&type=template&id=5502515a"
import script from "./Backorder.vue?vue&type=script&lang=js"
export * from "./Backorder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__